(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('navigationService', navigationService);

	navigationService.$inject = ['$rootScope', '$state', '$http', '$timeout', 'URLS', 'FIRST_VIEW', 'storeService', 'SETUP_PAGES', '$experiments'];

	function navigationService($rootScope, $state, $http, $timeout, URLS, FIRST_VIEW, storeService, SETUP_PAGES, $experiments) {
		var OBSOLETE_VIEWS = ['app.setup.updateTargets', 'app.setup.updateWeeklyTargets'];
		var supplierAlternatePaths = [
			{
				auth: ['leanProjects', 'viewProjects'],
				paths: ['app.supply-chain.redirects.supplier-projects', 'app.supply-chain.supplier-projects', 'app.lean-projects.edit-project', 'app.supply-chain.edit-project']
			}, {
				auth: ['supplyChain', 'purchaseOrderReceipts'],
				paths: ['app.supply-chain.redirects.purchase-order-receipts']
			}, {
				auth: ['supplyChain', 'purchaseOrderReceipts'],
				paths: ['app.supply-chain.redirects.purchase-order-receipts']
			}, {
				auth: ['supplyChain', 'purchaseRequisitions'],
				paths: ['app.supply-chain.redirects.supply-purchase-requisitions', 'app.supply-chain.purchase-reqs']
			}, {
				auth: ['supplyChain', 'purchaseOrders'],
				paths: ['app.supply-chain.redirects.supply-purchase-orders', 'app.supply-chain.purchase-reqs']
			}, {
				auth: ['supplyChain', 'workbench'],
				paths: ['app.supply-chain.workbench']
			}, {
				auth: ['supplyChain'],
				paths: ['app.supply-chain.supplier-on-hand-inventory']
			}, {
				auth: ['supplyChain'],
				paths: ['app.supply-chain.report-list']
			}, {
				auth: ['supplyChain'],
				paths: ['app.supply-chain.create-report']
			}, {
				auth: ['supplyChain'],
				paths: ['app.account.edit']
			}, {
				auth: ['supplyChain'],
				paths: ['app.setup.unsubscribe-email']
			}, {
				auth: ['supplyChain'],
				paths: ['app.chat-inbox']
			}
		];

		var service = {
			getViews: getViews,
			getDefaultView: getDefaultView,
			getViewMappings: getViewMappings,
			getFirstView: getFirstView,
			setFirstView: setFirstView,
			goToTabFirstView: goToTabFirstView,
			goToDefaultReportForTab: goToDefaultReportForTab,
			getCustomersForUser: getCustomersForUser,
			getFactoriesForUserAndCustomer: getFactoriesForUserAndCustomer,
			getLoginSiteForCustomer: getLoginSiteForCustomer,
			getDashboardStateName: getDashboardStateName,
			getStateForDashboard: getStateForDashboard,
			goToDefaultSupplierReport: goToDefaultSupplierReport,
			getFirstAuthorizedViewByViewType: getFirstAuthorizedViewByViewType,
			goToState: goToState,
			getFirstPermittedPath: getFirstPermittedPath
		};

		return service;

		function getViews() {
			var viewMappings = FIRST_VIEW.VIEW_MAPPINGS;
			var views = FIRST_VIEW.VIEWS;
			var result = {};
			for (var key in views) {
				var authList = [];
				var fullList = views[key];
				for (var i = 0; i < fullList.length; i++) {
					var view = fullList[i];
					var viewMapping = viewMappings[key][view.viewMappingsName];
					if (authorize(viewMapping.auth)) {
						authList.push(view);
					}
				}
				if (authList && authList.length) {
					result[key] = authList;
				}
			}
			return result;
		}

		/**
		 * First hash path the user is allowed to land on.
		 * Prefers dashboards; otherwise first authorized entry from getViews().
		 * Returns null when nothing permitted.
		 */
		function getFirstPermittedPath() {
			if (authorize(['dashboard'])) {
				return '/dashboard/list/0';
			}
			var views = getViews();
			for (var key in views) {
				if (!views.hasOwnProperty(key)) {
					continue;
				}
				for (var i = 0; i < views[key].length; i++) {
					var view = views[key][i];
					if (!view.url) {
						continue;
					}
					var hash = (view.url.split('#')[1] || '').replace(/\/$/, '');
					if (hash) {
						return hash;
					}
				}
			}
			return null;
		}

		function getDefaultView(viewType) {
			return {
				'reportName': FIRST_VIEW.DEFAULT_MAP[viewType],
				'baseReportName': FIRST_VIEW.DEFAULT_MAP[viewType]
			};
		}

		function getViewMappings() {
			return FIRST_VIEW.VIEW_MAPPINGS;
		}

		function getFirstView(viewType) {
			var firstViews = storeService.getState().firstView.firstViews;
			var firstView = _.find(firstViews, function (e) {
				return e.viewType === viewType;
			});
			return {
				'reportName': firstView ? firstView.baseReportName : FIRST_VIEW.DEFAULT_MAP[viewType],
				'id': firstView ? firstView.savedViewId : undefined
			};
		}

		function goToState(viewType) {
			if (viewType) {
				var state;
				if (viewType === 'dashboards') {
					$state.go('app.dashboard');
				} else {
					var data = getFirstView(viewType);
					var viewMappingInfo = getViewMappings()[viewType];
					if (viewMappingInfo && viewMappingInfo[data.reportName]) {
						if (globalConfig.user.role == 'Supplier') {
							if (_.indexOf(FIRST_VIEW.SUPPLIER_VIEWS, viewType) >= 0) {
								if ($rootScope.authorize(viewMappingInfo[data.reportName]['auth'])) {
									state = viewMappingInfo[data.reportName].sref;
								} else {
									state = getFirstAuthorizedViewByViewType(viewType);
								}
							}
						} else {
							state = viewMappingInfo[data.reportName].sref;
						}
					}
					if (state) {
						$state.go(state, { reportId: undefined });
					} else {
						var defaultState = getDefaultView(viewType);
						state = getViewMappings()[viewType][defaultState.reportName].sref;
						if (state) {
							$state.go(state, { reportId: undefined });
						}
					}
				}
			}
		};

		function setFirstView(reportSettings, reportName, baseReportName) {
			if (reportSettings.baseReportName === undefined) {
				reportSettings.baseReportName = baseReportName || reportName;
			}
			storeService.setFirstView(reportSettings.viewType, null, reportSettings.baseReportName, reportSettings.reportSettingsId);
		}

		function goToTabFirstView (tabLevelStateSref, defaultOverride, isSupplier) {
			if (tabLevelStateSref === 'dashboard') {
				$state.go('app.dashboard');
			}
			var firstViews = storeService.getState().firstView.firstViews;
			var firstView = _.find(firstViews, function (e) { return e.viewType === tabLevelStateSref; });

			if (firstView) {
				if ($experiments.isLeanOnly()) {
					limitFirstViewForLeanOnly(firstView);
				}
				var baseReportName = firstView.baseReportName;
				var sref = 'app.' + tabLevelStateSref + '.' + baseReportName;

				if (tabLevelStateSref === 'setup' && (OBSOLETE_VIEWS.indexOf(sref) !== -1 || !userIsAuthorizedForSetupPage(sref))) {
					goToDefaultReportForTab(tabLevelStateSref);
					return;
				}
				if (!!isSupplier) {
					if (!supplierIsAuthorizedForView(baseReportName, tabLevelStateSref)) {
						goToDefaultSupplierReport(tabLevelStateSref);
						return;
					}
				}

				if ($state.href(sref)) {
					var param = {};
					if (firstView.savedViewId) {
						param.reportId = firstView.savedViewId;
					}
					$state.go(sref, param);
					return;
				}
			}
			if (!!isSupplier) {
				goToDefaultSupplierReport(tabLevelStateSref);
				return;
			}
			if (defaultOverride) {
				$state.go(defaultOverride);
			} else {
				goToDefaultReportForTab(tabLevelStateSref);
			}
		};

		function limitFirstViewForLeanOnly(firstView) {
			if (firstView.viewType === 'my-work' && (firstView.baseReportName.includes('workbench') || firstView.baseReportName === 'my-inventory-opportunities')) {
				firstView.baseReportName = 'my-project-tasks';
			}
		}

		function supplierIsAuthorizedForView(baseReportName, tabLevelStateSref) {
			var supplierView = FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[baseReportName];
			if (_.indexOf(FIRST_VIEW.SUPPLIER_VIEWS, supplierView) >= 0) {
				var viewMapping = FIRST_VIEW.VIEW_MAPPINGS[supplierView];
				var mapping = _.find(viewMapping, { 'sref': 'app.' + tabLevelStateSref + '.' + baseReportName });
				if (mapping && $rootScope.authorize(mapping['auth'])) {
					return true;
				}
			}
			return false;
		}

		function userIsAuthorizedForSetupPage(sref) {
			if (SETUP_PAGES.CUSTOMER_ADMINS.indexOf(sref) >= 0) {
				return $rootScope.authz.isCustomerAdmin();
			}
			if (SETUP_PAGES.LEANDNA_CUSTOMER_ADMINS.indexOf(sref) >= 0) {
				return $rootScope.authz.isLeanDNACustomerAdmin();
			}
			if (SETUP_PAGES.LEANDNA_ADMINS.indexOf(sref) >= 0) {
				return $rootScope.authz.isLeanDNAAdmin();
			}
			return true;
		}

		function getReportAuthInAlternatePaths(sref) {
			var pathAuthorization = null;
			for (var i = 0, len = supplierAlternatePaths.length; i < len; i++) {
				if (_.includes(supplierAlternatePaths[i].paths, sref)) {
					pathAuthorization = supplierAlternatePaths[i]['auth'];
					break;
				}
			}
			return pathAuthorization;
		}

		function goToDefaultSupplierReport(tabLevelStateSref, checkForCurrentPath) {
			if (checkForCurrentPath) {
				var keys = Object.keys(FIRST_VIEW.VIEW_MAPPINGS);
				var isAuthorized = false;
				var sref = $state.current.name;
				if (sref === 'app.unauthorized') {
					return;
				}
				var alternateAuthorization = getReportAuthInAlternatePaths(sref);
				if (alternateAuthorization) {
					isAuthorized = $rootScope.authorize(alternateAuthorization);
				} else {
					for (var i = 0, len = keys.length; i < len; i++) {
						var mapping = _.find(FIRST_VIEW.VIEW_MAPPINGS[keys[i]], { 'sref': sref });
						if (mapping) {
							isAuthorized = $rootScope.authorize(mapping['auth']);
							break;
						};
					}
				}

				if (isAuthorized) {
					return;
				}
			}
			var mapping;
			for (var i = 0; i < FIRST_VIEW.SUPPLIER_VIEWS.length; i++) {
				var viewMapping = FIRST_VIEW.VIEW_MAPPINGS[FIRST_VIEW.SUPPLIER_VIEWS[i]];
				mapping = _.find(viewMapping, function (mapping) {
					return $rootScope.authorize(mapping['auth']);
				});
				if (mapping) {
					break;
				}
			}
			if (mapping) {
				$timeout(function () {
					$state.go(mapping['sref']);
				}, 0);
				return;
			}
			// check for project authorization
			if ($rootScope.authorize(['leanProjects', 'viewProjects'])) {
				$state.go('app.supply-chain.supplier-projects');
				return;
			}
			goToDefaultReportForTab(tabLevelStateSref);
		}

		function goToDefaultReportForTab(tabLevelStateSref) {
			var isLeanOnly = $experiments.isLeanOnly();

			var defaults = {
				'workbench': 'home',
				'my-work':  isLeanOnly ? 'my-project-tasks' : ($experiments.isEnabled('workbench') ? 'buyer-workbench/all' : 'my-inventory-opportunities'),
				'supply-chain': 'inventory-burnoff',
				'factory': 'report-card',
				'lean-projects': 'projects-kanban',
				'setup': 'data-pipeline',
				'company-setup': 'manage-users',
				'site-setup': 'factory-general-settings',
				'account': 'edit',
				'leandna-setup': (globalConfig.user.isCustomerAdministrator || globalConfig.user.profileType === 'SuperSystemAdministrator') ? 'create-factory' : 'customer-success-report'
			};
			var newState = 'app.' + tabLevelStateSref;
			if (defaults[tabLevelStateSref]) {
				newState += '.' + defaults[tabLevelStateSref];
			}
			$state.go(newState, {}, { inherit: false });
		}

		function getStateForDashboard(dashboardInfo) {
			if (dashboardInfo.id) {
				return {
					sref: getDashboardStateName(dashboardInfo.baseReportName),
					params: {id: dashboardInfo.id}
				};
			}
			return {
				sref: 'app.dashboard'
			};
		}

		function getDashboardStateName(baseReportName) {
			if(baseReportName === 'Data Health Dashboard'){
				return 'app.dashboard.quicksight';
			} else if (baseReportName === 'Superset') {
				return 'app.dashboard.superset';
			} else {
				return 'app.dashboard.home';
			}
		}

		function getCustomersForUser() {
			var url = URLS.host + '2/Dimensions/CustomersForUser';
			return $http.get(url)
				.then(getCustomersForUserSuccess)
				.catch(getCustomersForUserFailed);

			function getCustomersForUserSuccess(response) {
				return response.data;
			}

			function getCustomersForUserFailed(error) {
				return [{
					'name': globalConfig.customer.name,
					'ndx': globalConfig.customer.id
				}];
			}
		}

		function getFactoriesForUserAndCustomer(customerNdx) {
			var url = URLS.host + '2/Dimensions/Factories?excludeExternalSite=false&allCustomers=false&includeSupplier=true&opsFactNdx=' + globalConfig.factory.id;
			return $http.get(url)
				.then(getFactoriesForUserAndCustomerSuccess)
				.catch(getFactoriesForUserAndCustomerFailed);

			function getFactoriesForUserAndCustomerSuccess(response) {
				return response.data;
			}

			function getFactoriesForUserAndCustomerFailed(error) {
				return [{
					'name': globalConfig.factory.name,
					'id': globalConfig.factory.id
				}];
			}
		}

		function getLoginSiteForCustomer(customerNdx) {
			var url = URLS.host + URLS.prefix + globalConfig.factory.id + '/LastLoginSiteForUser?customerNdx=' + customerNdx;
			return $http.get(url)
				.then(getLoginSiteForCustomerSuccess)
				.catch(getLoginSiteForCustomerFailed);

			function getLoginSiteForCustomerSuccess(response) {
				return response.data;
			}

			function getLoginSiteForCustomerFailed(error) {
				return {
					'factoryNdx': globalConfig.factory.id
				};
			}
		}

		function getFirstAuthorizedViewByViewType(viewType) {
			var keys = Object.keys(FIRST_VIEW.VIEW_MAPPINGS[viewType]);
			var sref = null;
			if (keys) {
				for (var i = 0, len = keys.length; i < len; i++) {
					var mapping = FIRST_VIEW.VIEW_MAPPINGS[viewType][keys[i]];
					if ($rootScope.authorize(mapping['auth'])) {
						sref = mapping.sref;
						break;
					};
				}
			}
			return sref;
		}
	}
})();
